<template>
  <div>
    <b-container>
      <b-row class="p-1">
        <b-col>
          <b-button @click="exportTemplate">Export TEMPLATE</b-button>
        </b-col>
      </b-row>

      <b-row class="p-1">
        <b-col>
          <b-button @click="exportDicts">Export Dictionaries</b-button>
        </b-col>
      </b-row>
      <b-row class="p-1">
        <b-col>
          <b-button @click="exportCompanyConfiguration">Export Company Configuration</b-button>
        </b-col>
      </b-row>
      <b-row class="p-1">
        <b-col>
          <b-button @click="exportRolesAndPermissions">Export Roles</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          Import data
          <FileUpload
              data-test-path="form-file-upload"
              @file-selected="importFileSelected"
              ref="jsonUpload"
              :read-only="false"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import Rpc from "@/Rpc";
import FormsActions from "@/components/forms/FormsActions";
import CompanyConfiguration from "@/server/com/silkplm/model/plm/CompanyConfiguration";
import CompanyConfigurationForm from "@/server/com/silkplm/model/plm/CompanyConfigurationForm";
import CompanyConfigurationFormField from "@/server/com/silkplm/model/plm/CompanyConfigurationFormField";
import FileUpload from "@/components/FileUpload.vue";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import EventBus from "@/utils/EventBus";
import ServerEvents from "@/server/ServerEvents";

export default {
  name: "ExportImport",
  components: {FileUpload},

  mounted() {
    this.$onEvent(ServerEvents.delayedTaskComplete, async taskResult => {
      if (taskResult.taskId === this.delayedTask?.taskId) {
        if (taskResult.error?.length) {
          await DialogManager.info($tr("exportImport.importFileFailure", "Import Failure."), "Import Failure.");
        } else {
          await DialogManager.info($tr("exportImport.importFileSuccess", "Import Success."), "Import Success.");
        }
      }
    });
  },
  methods: {

    async exportDicts() {
      let nonExportable = await Rpc.DictExportImport.nonDictTypes().lock();
      let classes = await FormsActions.showMultiSelectList(CompanyConfigurationForm, {}, nonExportable);
      let selected = await classes.getResult();
      let selectedIds = [];

      if (selected.materialize) {
        await selected.materialize();
        for (let c of selected) {
          selectedIds.push(c);
        }
      }

      let allCompanyConfigurationForms = await CompanyConfigurationForm.list();
      let map = new Map();
      allCompanyConfigurationForms.forEach(item => map.set(item.id.toString(), item));

      let names = [];
      for (let idObj of selectedIds) {
        let id = idObj.id;
        let conf = map.get(id)
        let form = FormsLoader.detectFormConfig(conf.formId);
        names.push(form.formClassLong);
      }
      await Rpc.DictExportImport.export(names, "Dictionaries Export").lock();
    },

    async exportTemplate() {
      try {
        let nonExportable = await Rpc.DictExportImport.nonExportableTypeNames().lock();
        await Rpc.DictExportImport.export(nonExportable, "TEMPLATE Export").lock();
      } finally {
      }
    },


    async exportAllObjects() {
      try {
        let nonExportable = await Rpc.DictExportImport.nonDictTypes().lock();
        let classes = await FormsActions.showMultiSelectList(CompanyConfigurationForm, {}, nonExportable);
        let selected = await classes.getResult();
        let names = [];
        for (let c of selected) {
          let form = FormsLoader.detectFormConfig(c.formId);
          names.push(form.formClassLong);
        }
        await Rpc.DictExportImport.export(names, "Dictionaries Export").lock();
      } finally {
      }
    },


    async exportCompanyConfiguration() {
      let names = await Rpc.DictExportImport.getCompanyConfigurationForms();
      await Rpc.DictExportImport.export(names, "Company Configuration Export").lock();
    },
    async exportRolesAndPermissions() {
      let names = await Rpc.DictExportImport.getRoleForms();
      await Rpc.DictExportImport.export(names, "Roles Export").lock();
    },
    async importFileSelected() {
      let avatarUpload = this.$refs.jsonUpload;
      let file = avatarUpload.getFile();
      avatarUpload.setProgress(0);
      try {
        let companyConfigurationFormsList = await CompanyConfigurationForm.list();
        if (!companyConfigurationFormsList.length) {
          await Rpc.plm.services.CompanyConfigurationService.updateCompanyConfigurationFormAndFields().lock();
        }
        try {
          this.delayedTask = await Rpc.DictExportImport.importFile(file).lock();
        } catch (e) {
          console.log(e);
        }
        avatarUpload.reset();
      } catch (e) {
        if (e instanceof RpcInputValidationException) {
          avatarUpload.setError(e.fields.image.errorMessage);
        }
      }
    },
  },
  data() {
    return {
      src: "",
    }
  }
}
</script>